/**
 * Styled Components - Created by cazarez on 11/04/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import {
  WHITE,
  GRAY_DARK,
  GRAY,
  RED,
  RED_TRANSPARENT,
  BLACK_LIGHT
} from '../../theme/colors'
import { BLACK } from '../../screens/DesignerTool/constants'
import Icon from 'antd/lib/icon'

interface DivProps {
  small?: boolean
}

export const Container = styled.div`
  border-radius: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
    opacity: 0.8;
  }
  @media (min-width: 320px) and (max-width: 680px) {
    width: 100%;
  }
`

export const StatusContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: end;
  padding-top: 8px;
`

export const StatusCard = styled.div<{ $status: boolean }>`
  border-radius: 4px;
  color: ${props => props.$status ? '#666868' : 'white'};
  background-color: ${props => props.$status ? '#dcf8ff' : '#5f6062'};;
  padding: 4px 6px;
  font-size: 12px;
  letter-spacing: 1px;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const StyledImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
  max-height: 90px;
`

export const TitleName = styled.div`
  height: 84px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: ${GRAY};
  color: ${BLACK};
  font-size: 18px;
}`

export const TeamStoreCard = styled.div`
  width: ${({ small }: DivProps) => (small ? '412px' : '658px')};
  position: relative;
  box-shadow: 1px 2px 5px 0px #a1a1a1;
  border-radius: 10px;
  @media (max-width: 1648px) {
    width: ${({ small }: DivProps) => (small ? '410px' : '600px')};
  }
  @media (max-width: 1375px) {
    width: ${({ small }: DivProps) => (small ? '345px' : '545px')};
  }
  @media (max-width: 1224px) {
    width: ${({ small }: DivProps) => (small ? '280px' : '430px')};
  }
  @media (max-width: 1024px) {
    width: ${({ small }: DivProps) => (small ? '270px' : '415px')};
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`

export const StoreName = styled.div`
  margin-top: 4px;
  text-align: center;
  font-weight: 500;
  font-family: Avenir;
  font-size: 13px;
  left:0;
  right:0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
`

export const ImportedLabel = styled.div`
  font-size: 12px;
  position: absolute;
  left: 7px;
  top: -9px;
  z-index: 2;
  background: white;
  border-radius: 25px;
  padding: 4px 10px;
  padding-left: 10px;
  box-shadow: 1px 2px 3px -1px #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f1f1f1;
`

export const ImportedIcon = styled(Icon)`
  transform: rotate(-90deg);
  color: #7c61b4;
  margin-right: 6px;
`

interface CardProps {
  closedMessage?: string
}

export const CardContent = styled.div`
  background-color: ${WHITE};
  position: relative;
  border-radius: 10px;
  &: before {
    background: ${({ closedMessage }: CardProps) =>
    closedMessage ? RED_TRANSPARENT : 'none'};
    color: ${BLACK};
    top: 8px;
    padding: 5px;
    position: absolute;
    text-align: center;
    border-radius: 10px;
    content: ${({ closedMessage }: CardProps) => `'${closedMessage}'`};
    width: 100%;
  }
`

export const CardTitle = styled.div`
  cursor: text;
  text-shadow: 0px 2px 4px ${GRAY_DARK};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StoreType = styled.div`
  cursor: text;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  text-align: center;
  background: ${BLACK_LIGHT};
  border: 1px solid ${WHITE};
  color: ${WHITE};
  font-weight: 500;
  height: 24px;
  padding: 0 12px;
  @media (max-width: 480px) {
    line-height: 20px;
    min-width: 45%;
    border-color: ${GRAY};
  }
`

export const BottomContainer = styled.div`
  color: ${WHITE};
  font-size: 18px;
  width: 100%;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  position: absolute;
  bottom: 0px;
  padding: 2px 4px;
  display: flex;
  justify-content: flex-end;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

export const ShareButton = styled(Button)`
  height: fit-content;
  border: 1px solid #ffffff5c;
  border-radius: 5px;
  background-color: #ffffff5e;
  span {
    color: #ffffffcf;
    font-size: 14px;
    letter-spacing: 0.1px;
    line-height: 19px;
    text-align: center;
  }

  @media (max-width: 480px) {
    display: none;
  }
`

export const EditButton = ShareButton.extend``

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 480px) {
    width: 100%;
    justify-content: center;
    margin-top: 8px;
  }
`
export const DeleteLabel = styled.span`
  display: flex;
  align-items: center;
  color: ${WHITE};
  font-size: 14px;
  font-weight: normal;
  background: ${RED};
  justify-content: center;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  margin-left: 10px;
  padding: 0 12px;
  @media (max-width: 480px) {
    margin-left: 0;
    width: 76px;
  }
`

export const CodeLabel = styled.div`
  position: absolute;
  right: 0;
  z-index: 2;
  display: flex;
  background: #ffffffe6;
  padding: 2px 12px;
  font-family: Avenir;
  border-radius: 25px;
  top: -10px;
  box-shadow: 1px 2px 3px -1px #9f9f9f;
  border-top: 1px solid #f1f1f1;
  font-size: 12px;
`

export const CodeIcon = styled(Icon)`
  margin-right: 6px;
  margin-left: -2px;
  color: #bf9952;
`

export const CodeText = styled.div`
  margin-right: 4px;
  font-weight: 500;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreItemList/styledComponents.tsx